module.exports = __webpack_public_path__ + "img/Sports.0dfaa199.svg";